/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingRequestRead } from '../models/BookingRequestRead';
import type { CancelBookingRequest } from '../models/CancelBookingRequest';
import type { ConfirmBookingRequest } from '../models/ConfirmBookingRequest';
import type { FileBookingRequest } from '../models/FileBookingRequest';
import type { FileBookingRequestRead } from '../models/FileBookingRequestRead';
import type { PaginatedBookingRequestReadList } from '../models/PaginatedBookingRequestReadList';
import type { PaginatedBookingRequestUpdateList } from '../models/PaginatedBookingRequestUpdateList';
import type { RespondBookingRequest } from '../models/RespondBookingRequest';
import type { UpdateBookingRequestByStaff } from '../models/UpdateBookingRequestByStaff';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BookingRequestsService {

    /**
     * Copy of django-rest-framework's `ListAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns PaginatedBookingRequestReadList
     * @throws ApiError
     */
    public static bookingRequestsList({
        date,
        dateFrom,
        dateTo,
        healthcareFacility,
        limit,
        offset,
        provider,
        search,
        searchByProvider,
        sortBy,
        sortDirection,
        specialties,
        statusIn,
    }: {
        /**
         * * `PAST` - Past
         * * `UPCOMING` - Upcoming
         * * `ARCHIVE` - Archive
         * * `ALL` - All
         */
        date?: 'ALL' | 'ARCHIVE' | 'PAST' | 'UPCOMING',
        dateFrom?: string,
        dateTo?: string,
        healthcareFacility?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        provider?: Array<string>,
        /**
         * Search
         */
        search?: string,
        /**
         * Search by Provider
         */
        searchByProvider?: string,
        /**
         * Sort By
         *
         * * `first_shift` - First Shift
         * * `last_shift` - Last Shift
         * * `created_at` - Created At
         * * `updated_at` - Updated At
         * * `healthcare_facility__name` - Facility Name
         * * `status` - Status
         * * `healthcare_entity_rep__user__first_name` - Healthcare Representative First Name
         * * `healthcare_entity_rep__user__last_name` - Healthcare Representative
         * * `provider__first_name` - Provider First Name
         * * `provider__last_name` - Provider Last Name
         * * `provider__specialties` - Provider Specialty
         * * `shift_count` - Shift Count
         * * `total_payment` - Total Payment
         * * `code` - Code
         */
        sortBy?: 'code' | 'created_at' | 'first_shift' | 'healthcare_entity_rep__user__first_name' | 'healthcare_entity_rep__user__last_name' | 'healthcare_facility__name' | 'last_shift' | 'provider__first_name' | 'provider__last_name' | 'provider__specialties' | 'shift_count' | 'status' | 'total_payment' | 'updated_at',
        /**
         * Sort Direction
         *
         * * `asc` - Ascending
         * * `desc` - Descending
         */
        sortDirection?: 'asc' | 'desc',
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `CARDIOVASCULAR_DISEASE` - Cardiovascular Disease
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospitalist
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'CARDIOVASCULAR_DISEASE' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY' | null>,
        /**
         * Multiple values may be separated by commas.
         */
        statusIn?: Array<string>,
    }): CancelablePromise<PaginatedBookingRequestReadList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/booking-requests/',
            query: {
                'date': date,
                'date_from': dateFrom,
                'date_to': dateTo,
                'healthcare_facility': healthcareFacility,
                'limit': limit,
                'offset': offset,
                'provider': provider,
                'search': search,
                'search_by_provider': searchByProvider,
                'sort_by': sortBy,
                'sort_direction': sortDirection,
                'specialties': specialties,
                'status__in': statusIn,
            },
        });
    }

    /**
     * @returns BookingRequestRead
     * @throws ApiError
     */
    public static bookingRequestsRetrieve({
        requestId,
    }: {
        requestId: string,
    }): CancelablePromise<BookingRequestRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/booking-requests/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * @returns BookingRequestRead
     * @throws ApiError
     */
    public static bookingRequestsUpdate({
        requestId,
        requestBody,
    }: {
        requestId: string,
        requestBody?: UpdateBookingRequestByStaff,
    }): CancelablePromise<BookingRequestRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/booking-requests/{request_id}/',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns FileBookingRequestRead
     * @throws ApiError
     */
    public static bookingRequestsAttachmentsRetrieve({
        requestId,
    }: {
        requestId: string,
    }): CancelablePromise<FileBookingRequestRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/booking-requests/{request_id}/attachments',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * @returns FileBookingRequestRead
     * @throws ApiError
     */
    public static bookingRequestsAttachmentsUpdate({
        requestId,
        requestBody,
    }: {
        requestId: string,
        requestBody?: FileBookingRequest,
    }): CancelablePromise<FileBookingRequestRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/booking-requests/{request_id}/attachments',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns CancelBookingRequest
     * @throws ApiError
     */
    public static bookingRequestsCancelUpdate({
        requestId,
        requestBody,
    }: {
        requestId: string,
        requestBody?: CancelBookingRequest,
    }): CancelablePromise<CancelBookingRequest> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/booking-requests/{request_id}/cancel/',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ConfirmBookingRequest
     * @throws ApiError
     */
    public static bookingRequestsConfirmUpdate({
        requestId,
        requestBody,
    }: {
        requestId: string,
        requestBody?: ConfirmBookingRequest,
    }): CancelablePromise<ConfirmBookingRequest> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/booking-requests/{request_id}/confirm/',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Copy of django-rest-framework's `ListAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns PaginatedBookingRequestUpdateList
     * @throws ApiError
     */
    public static bookingRequestsHistoryList({
        requestId,
        limit,
        offset,
    }: {
        requestId: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedBookingRequestUpdateList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/booking-requests/{request_id}/history/',
            path: {
                'request_id': requestId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * @returns RespondBookingRequest
     * @throws ApiError
     */
    public static bookingRequestsRespondUpdate({
        requestId,
        requestBody,
    }: {
        requestId: string,
        requestBody?: RespondBookingRequest,
    }): CancelablePromise<RespondBookingRequest> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/booking-requests/{request_id}/respond/',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
